import React, { useMemo } from "react";
import { Tooltip } from "react-tooltip";
import SortableTh from "../../components/common/SortableTh";
import PatternRow from "./PatternRow";
import { formatNumber, OUTLIER_TOOLTIP } from "./utils";

const PatternsTable = ({
  patterns,
  baseline,
  sortBy,
  sortDir,
  onSort,
  audienceHash,
  patternType,
}) => {
  const maxVideoCount = useMemo(() => {
    let max = 0;
    for (const p of patterns) {
      const c = p.stats?.video_count;
      if (typeof c === "number" && c > max) max = c;
    }
    return max;
  }, [patterns]);

  return (
    <div className="rounded-lg border border-theme-secondary bg-theme-main overflow-x-auto">
      <table className="min-w-full divide-y divide-theme-secondary table-fixed">
        <colgroup>
          <col style={{ width: "360px" }} />
        </colgroup>
        <thead>
          <tr className="bg-theme-secondary">
            <SortableTh
              label="Pattern"
              tooltip="Pattern name or identifier"
              sortKey="pattern"
              sortBy={sortBy}
              sortDirection={sortDir}
              onSort={onSort}
              activeClassName="patterns-sort-th-active"
              showSortArrow={false}
            />
            <SortableTh
              label="Likes"
              tooltip="Median likes per video in this pattern."
              sortKey="likes"
              sortBy={sortBy}
              sortDirection={sortDir}
              onSort={onSort}
              align="right"
              activeClassName="patterns-sort-th-active"
              showSortArrow={false}
            />
            <SortableTh
              label="Outlier"
              tooltip={OUTLIER_TOOLTIP}
              sortKey="likes_outlier"
              sortBy={sortBy}
              sortDirection={sortDir}
              onSort={onSort}
              activeClassName="patterns-sort-th-active"
              showSortArrow={false}
            />
            <SortableTh
              label="Views"
              tooltip="Median views per video in this pattern. View data is not always available (e.g. for some Instagram videos)."
              sortKey="views"
              sortBy={sortBy}
              sortDirection={sortDir}
              onSort={onSort}
              activeClassName="patterns-sort-th-active"
              showSortArrow={false}
              align="right"
            />
            <SortableTh
              label="Outlier"
              tooltip={OUTLIER_TOOLTIP}
              sortKey="views_outlier"
              sortBy={sortBy}
              sortDirection={sortDir}
              onSort={onSort}
              activeClassName="patterns-sort-th-active"
              showSortArrow={false}
            />
            <SortableTh
              label="Comments"
              tooltip="Median comments per video in this pattern."
              sortKey="comments"
              sortBy={sortBy}
              sortDirection={sortDir}
              onSort={onSort}
              activeClassName="patterns-sort-th-active"
              showSortArrow={false}
              align="right"
            />
            <SortableTh
              label="Outlier"
              tooltip={OUTLIER_TOOLTIP}
              sortKey="comments_outlier"
              sortBy={sortBy}
              sortDirection={sortDir}
              onSort={onSort}
              activeClassName="patterns-sort-th-active"
              showSortArrow={false}
            />
            <SortableTh
              label="Count"
              tooltip="Number of videos in this pattern"
              sortKey="count"
              sortBy={sortBy}
              sortDirection={sortDir}
              onSort={onSort}
              activeClassName="patterns-sort-th-active"
              showSortArrow={false}
            />
            <th className="w-24 px-4 py-2" aria-hidden="true" />
          </tr>
        </thead>
        <tbody>
          {patterns.map((pattern) => (
            <PatternRow
              key={pattern.id}
              pattern={pattern}
              baseline={baseline}
              maxVideoCount={maxVideoCount}
              formatNumber={formatNumber}
              audienceHash={audienceHash}
              patternType={patternType}
            />
          ))}
        </tbody>
      </table>
      <Tooltip
        id="pattern-analysis-tip"
        place="top"
        className="!max-w-sm !whitespace-pre-line !text-xs !leading-relaxed"
      />
    </div>
  );
};

export default PatternsTable;
